import { useEffect } from "react";
import { GetVehicleWithDocumentById } from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer
 */

// This component fetches vehicle details (along with its documents) by ID
export const CommonVehicleDetails = ({
                                         dispatch,
                                         params,
                                         setElementDetails,
                                         setElementDocuments,
                                         modified, setModified
                                     }) => {

    // Destructure contractId and vehicle id from route parameters
    const { contractId, id } = params;

    // Fetch vehicle data on component mount
    useEffect(() => {
        getData();
    }, []); // Empty dependency array means this runs once on mount

    useEffect(() => {
        if(modified){
            setModified(false);
            getData();
        }
    }, [modified]);

    const getData = () => {
        dispatch(GetVehicleWithDocumentById(id)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                // If the API call is successful, update the vehicle details and documents
                if (success === true) {
                    setElementDetails(data);
                    setElementDocuments(data?.documents);
                }
            },
        );
    }

    // Return the contractId for use elsewhere if needed
    return {
        contractId
    };
};
